module.exports = __webpack_public_path__ + "static/img/3.72d1c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/categories/3.jpg
// module id = jE5B
// module chunks = 0